import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { rValue } from '../../models/.catalog';
import pKullaniciKontrol from '../../models/pKullaniciKontrol';

export default class KullaniciKontrolApi extends ApiBase<pKullaniciKontrol, rValue<boolean>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/KullaniciKontrol',
      }),
      options
    );
    this._ServiceUrl = '/services/Kullanici.asmx';
  }
}
